import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import HeaderActionBar from "../Dashboard/HeaderActionBar/HeaderActionBar";
import classes from "./Welcome.module.css"
import StudyGroup from "./StudyGroup";
import ActionBar from "../Dashboard/ActionBar/ActionBar";
import { onKeyDown } from "../../../service";

const Welcome = () => {

    const { welcomeText, welcomeImage, logo, backgroundColor } = useSelector(state => state.application);
    const { lang, texts } = useSelector(state => state.translate);
    const { curriculums } = useSelector(state => state.curriculums);
    const [filteredList, setFillterdList] = useState()
    const [chosenLang, setChosenLang] = useState()

    useEffect(() => {
        setChosenLang(lang)
    }, [lang])

    useEffect(() => {
        if (curriculums) {
            setFillterdList(curriculums);
            changeChosenLang(lang)
        }
    }, [curriculums])

    function changeChosenLang(lang) {
        setChosenLang(lang)
        const filtered = curriculums?.filter(c => {
            return c.course?.lang === lang;
        });
        setFillterdList(filtered)
    }

    return <div className={classes.WelcomePage} style={backgroundColor ? { background: backgroundColor } : {}} >
        <div className={classes.ActionBar}>
            <ActionBar showActions={false}></ActionBar>
        </div>
        <HeaderActionBar hideLogo />
        <div className={classes.Header} style={{ backgroundImage: `url(${welcomeImage})` }}>
            <div className={classes.HeaderLogo} style={{ backgroundImage: `url(${logo})` }}></div>
            <h1 className={classes.HeaderTitle}>{texts.welcome} </h1>
            <h2 className={classes.HeaderText}>{welcomeText && welcomeText[lang]} </h2>
        </div>
        <div className={classes.Content}>
            <h3 className={classes.ContetnTitle}>{texts.dashboardMyCourses}</h3>
            <div className={classes.MySG}>
                {curriculums && curriculums.filter(sg => sg.isParticipant).map(sg => <StudyGroup key={sg.id} {...sg}></StudyGroup>)}
            </div>
            <div className={classes.ContetnTitleWrap}>
                <h3 className={classes.ContetnTitle}>{texts.discoverMoreCourses}</h3>
                <div className={classes.LangBtns}>
                    <div className={`${classes.LangBtn} ${classes.He} ${chosenLang === 'he' ? classes.CurrentLang : ''}`} onClick={() => changeChosenLang('he')} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeChosenLang('he'))}>ע</div>
                    <div className={`${classes.LangBtn} ${classes.Ar} ${chosenLang === 'ar' ? classes.CurrentLang : ''}`} onClick={() => changeChosenLang('ar')} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeChosenLang('ar'))}>ع</div>
                    <div className={`${classes.LangBtn} ${classes.Ar} ${chosenLang === 'en' ? classes.CurrentLang : ''}`} onClick={() => changeChosenLang('en')} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeChosenLang('en'))}>E</div>
                </div>
            </div>
            <div>
                <div className={classes.MySG}>
                    {filteredList && filteredList.filter(sg => !sg.isParticipant).map(sg => <StudyGroup key={sg.id}  {...sg}></StudyGroup>)}
                    {(!filteredList || (filteredList && filteredList.filter(sg => !sg.isParticipant).length === 0)) && <div className={classes.noSGMessage}>{texts.noSGMessage}</div>}
                </div>
            </div>
        </div>
    </div>
}

export default Welcome;